import { clp, formatClp as formatClpDomain } from '@condo/domain-chile';

/**
 * Formats an integer CLP amount as "$1.234.567".
 * Delegates to @condo/domain-chile for consistency.
 */
export function formatClp(amount: number): string {
  return formatClpDomain(clp(amount));
}

/** Compact format for dashboard cards: "$1,2M", "$850k". */
export function formatClpCompact(amount: number): string {
  const abs = Math.abs(amount);
  if (abs >= 1_000_000_000) return `$${(amount / 1_000_000_000).toFixed(1).replace('.', ',')}MM`;
  if (abs >= 1_000_000) return `$${(amount / 1_000_000).toFixed(1).replace('.', ',')}M`;
  if (abs >= 1_000) return `$${Math.round(amount / 1_000)}k`;
  return formatClp(amount);
}

/** Parses a user-entered "$1.234.567" back to integer pesos. */
export function parseClpInput(input: string): number {
  const digits = input.replace(/[^\d-]/g, '');
  if (!digits || digits === '-') return 0;
  return parseInt(digits, 10);
}
